import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import languageDetector from 'i18next-browser-languagedetector';
import studentsTranslationEN from './translations/en.json';
import studentsTranslationES from './translations/es.json';
import studentsTranslationPT from './translations/pt.json';
export const resources = {
    en: {
        translations: Object.assign({}, studentsTranslationEN),
    },
    es: {
        translations: Object.assign({}, studentsTranslationES),
    },
    pt: {
        translations: Object.assign({}, studentsTranslationPT),
    },
};
i18n
    .use(languageDetector)
    .use(initReactI18next)
    .init({
    resources: resources,
    fallbackLng: 'es',
    debug: true,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: '.',
    interpolation: {
        escapeValue: false,
    },
});
export default i18n;
